export default {
  en: {
    'components.registration-access-selector.no-reg':
      'There are no registrations available on this entity.',
    'components.registration-access-selector.no-entities':
      'Please select entities to set user access.',
    'components.registration-access-selector.registrations.fetch.fallback-error':
      'Failed to fetch registrations.',
    'components.registration-access-selector.registrations.data-threshold.fallback-error':
      'Your access cannot be adjusted in the app. Please contact support to make changes.',
    'components.registration-access-selector.permissions.update.success':
      'Access to registrations successfully updated.',
    'components.registration-access-selector.permissions.update.fallback-error':
      'Failed to update user access. Please try again.',
  },
};
